<template>
  <div class="time-zone-view">
    <div class="time-zone-view__title">{{title}}</div>
    <div class="time-zone-view__description">{{description}}</div>
  </div>
</template>


<style scoped lang="scss">
  .time-zone-view{
    &__title{
      color: var(--attendee-text-primary-color);
      font-size: 19px;
      font-weight: 600;
    }

    &__description{
      font-size: 11px;
      color: var(--attendee-text-secondary-color)
    }
  }
</style>

<script>

export default {
  props: ['title', 'description']
}
</script>